export default "/images/bl-img-2.jpg?d318de83ba91a811a1c9b3e6fa06e1e3";